import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { ColumnDefinition, TabulatorFull } from "tabulator-tables";
// import "tabulator-tables/dist/css/tabulator.min.css"; //import Tabulator stylesheet
import "./Tabulator.css";

type TabulatorProps = {
  data: any[];
  columns: ColumnDefinition[];
  layout?:
    | "fitData"
    | "fitColumns"
    | "fitDataFill"
    | "fitDataStretch"
    | "fitDataTable"
    | undefined;
  selectableRows?: boolean |number;
  onSelectRows?: Function;
  onRendered?: any;
  customFooter?: any
};

const Tabulator = forwardRef(
  (
    {
      data,
      columns,
      layout = "fitColumns",
      selectableRows = false,
      onSelectRows,
      onRendered,
      customFooter=null
    }: TabulatorProps,
    ref
  ) => {
    const domNodeRef = useRef<any>(null);
    const tabulatorInstanceRef = useRef<any>(null);
    useImperativeHandle(
      ref,
      () => ({
        tabulatorInstance: () => tabulatorInstanceRef.current,
      }),
      []
    );
    useEffect(() => {
      tabulatorInstanceRef.current = new TabulatorFull(domNodeRef.current, {
        data: data, //link data to table
        reactiveData: false, //enable data reactivity
        columns: columns, //define table columns
        layout: layout,
        selectableRows: selectableRows,
        footerElement:customFooter
        // selectableRowsRangeMode: "click",
        // sortMode: "remote",
        // ajaxSorting: true,
      });
      tabulatorInstanceRef.current.on("tableBuilt", () => {
        // tabulatorInstanceRef.current.setData(data)
        tabulatorInstanceRef.current.on("rowSelectionChanged", (data: any) => {
          if (onSelectRows) {
            onSelectRows(data);
          }
        });
        if (onRendered) {
          onRendered();
        }
      });
    }, [columns, customFooter, data, layout, onRendered, onSelectRows, selectableRows]);

    return <div style={{ width: "100%" }} ref={domNodeRef}></div>;
  }
);

export default Tabulator;
